import { render } from "./DependencyFields.vue?vue&type=template&id=50a06fac"
import script from "./DependencyFields.vue?vue&type=script&lang=js"
export * from "./DependencyFields.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__